export const SEQUENCE_STATUS = Object.freeze({
  initial: {
    title: 'Not started',
    color: '#6b7280'
  },
  expired: {
    title: 'Expired',
    color: '#f59e0b'
  },
  in_progress: {
    title: 'In Progress',
    color: '#3b82f6'
  },
  rejected: {
    title: 'Rejected',
    color: '#ef4444'
  },
  completed: {
    title: 'Completed',
    color: '#10b981'
  },
  approved: {
    title: 'Approved',
    color: '#10b981'
  }
})

export const SEQUENCE_TYPES = Object.freeze({
  onboarding: {
    title: 'Onboarding'
  },
  departure: {
    title: 'Departure'
  },
  training: {
    title: 'Training'
  },
  orientation: {
    title: 'Orientation'
  }
})

export const SEQUENCE_STEP_STATUS = Object.freeze({
  initial: {
    title: 'Incomplete',
    color: '#ef4444',
    icon: 'mdi:close-circle-outline'
  },
  completed: {
    title: 'Completed',
    color: '#10b981',
    icon: 'mdi:check-circle-outline'
  }
})

export const SEQUENCE_APPROVE_BLOCK_REASONS = Object.freeze({
  MISSING_PERMISSION:
    'You do not have permission to approve this onboarding. Ask an administrator for Manage Documents access.',
  STEPS_NOT_REVIEWED:
    'Review every onboarding step first. Each step must be approved or declined before final approval.',
  AGREEMENT_NOT_CONFIRMED: 'Confirm the statement in Admin Signature: "I agree that all data is true and correct".',
  REQUIRED_ADMIN_DOCUMENTS: 'Attach all required administrator documents before approving onboarding.'
})
